module.exports = __webpack_public_path__ + "static/media/priceNew.19652bad.svg";